import { MeasurableGroupType } from '@upright/common/model/input/measurable-group/types';
import { EmptyStateFundNoData } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-state-fund-no-data';
import { GenericEmptyState } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/generic-empty-state';
import { useInsightsLensContext } from '@upright/ui/common/upright/core/impact-lenses/insights/common/use-insights-lens-context';

export function InsightsLensEmptyState() {
  const ctx = useInsightsLensContext();
  if (ctx?.data.groupType === MeasurableGroupType.FUND) {
    return <EmptyStateFundNoData message="This fund has not yet provided its impact insights to Upright." />;
  }
  return (
    <GenericEmptyState
      dataTitle="Impact insights"
      noDataMessage="This company has not yet provided its impact insights."
    />
  );
}
